import { InjectionToken } from '@angular/core';
import { PageName, SectionName } from './base-event.model';

export const TRACKABLE_COMPONENT_NAME = new InjectionToken<SectionName>('TRACKABLE_COMPONENT_NAME');
export const TRACKABLE_SCREEN_NAME = new InjectionToken<PageName>('TRACKABLE_SCREEN_NAME');
